export default "__VITE_ASSET__BB8kPzP8__"